 
import { Button } from '@mantine/core';
import { variants } from '@uag/react-core';
import clsx from 'clsx';
import { ReactNode } from 'react';

type ToggleButtonProps = {
    children: ReactNode
    selected: boolean
    onClick: () => void
}

export const ToggleButton = ({ children, selected, onClick }: ToggleButtonProps) => {
    return (
        <Button
            className={clsx({ 'pointer-events-none': selected })}
            variant={!selected ? variants.button.secondary : undefined}
            onClick={onClick}>
            {children}
        </Button>
    );
};